// Chakra Imports
import {
  Avatar,
  Button,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue
} from '@chakra-ui/react';

import { Portal } from '@chakra-ui/react';
import { authRepository, User } from 'api/authRepository';
import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';
// React Router
import { useNavigate } from 'react-router-dom';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
// Assets
import Configurator from 'components/navbar/Configurator';
import { useAuth } from 'contexts/authContext';
import { MdNotificationsNone } from 'react-icons/md';
import useRoutes from 'routes';

export default function HeaderLinks(props: {
  secondary: boolean;
  [x: string]: any;
}) {
  const { secondary, theme, setTheme } = props;
  const routes = useRoutes()
  const { logout } = useAuth()

  // Chakra Color Mode
  const navbarIcon = useColorModeValue('gray.400', 'white');
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('black', 'white');
  const textColorBrand = useColorModeValue('brand.700', 'brand.400');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const borderButton = useColorModeValue('secondaryGray.500', 'whiteAlpha.200');

  const navigate = useNavigate();
  const [firstName, setFirstName] = useState<string>('User');

  const handleLogout = () => {
    logout()
    navigate('/auth/sign-in');
  };

  useEffect(() => {
    const fetchUserProfile = async () => {
      const token = localStorage.getItem('jwt');
      if (!token) return;

      try {
        const decoded: any = jwtDecode(token);
        const id = decoded['id']; // userId from JWT payload
        if (!id) {
          return;
        }

        const user: User = await authRepository.getUserById(id);
        setFirstName(user.firstName || 'User');
      } catch (error) {
      }
    };

    fetchUserProfile();
  }, []);

  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="999px"
      boxShadow={shadow}
    >
      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="20px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            ETH
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={routes} />
      <Menu>
        <Button
          p="0px"
          variant="ghost"
          bg="transparent"
          _hover={{ bg: "transparent" }}
          _active={{ bg: "transparent" }}
        >
          <Icon
            mt="6px"
            as={MdNotificationsNone}
            color={navbarIcon}
            w="20px"
            h="20px"
            me="10px"
            onClick={() => navigate("/admin/notification/NotificationList")}
          />
        </Button>
        <MenuList
          boxShadow={shadow}
          p="20px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
          mt="22px"
          me={{ base: '30px', md: 'unset' }}
          minW={{ base: 'unset', md: '400px', xl: '450px' }}
          maxW={{ base: '360px', md: 'unset' }}
        >
          <Flex w="100%" mb="20px">
            <Text fontSize="md" fontWeight="600" color={textColor}>
              Notifications
            </Text>
          </Flex>
          {/* <Flex flexDirection="column">
           
          </Flex> */}
        </MenuList>
      </Menu>

      <Menu>
        <MenuButton p="0px">
        </MenuButton>
      </Menu>
      <Configurator
        mini={props.mini}
        setMini={props.setMini}
        theme={theme}
        setTheme={setTheme}
      />

      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color={textColor}
            name={firstName || 'User'}
            bg="#4F6BFF"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <Portal>
          <MenuList
            boxShadow={shadow}
            p="0px"
            mt="10px"
            borderRadius="20px"
            bg={menuBg}
            border="none"
            zIndex={3000}
            position="relative"
          >
            <Flex w="100%" mb="0px">
              <Text
                ps="20px"
                pt="16px"
                pb="10px"
                w="100%"
                borderBottom="1px solid"
                borderColor={borderColor}
                fontSize="sm"
                fontWeight="700"
              // color={textColor}
              >
                👋&nbsp; Hey, {firstName || 'User'}
              </Text>
            </Flex>
            <Flex flexDirection="column" p="10px">

  {/* PROFILE SETTINGS */}
  <MenuItem
    onClick={() => navigate('/admin/userprofile')}
    bg="transparent"
    _hover={{ bg: "transparent" }}
    _focus={{ bg: "transparent" }}
    px="0"
  >
    <Flex
      w="100%"
      px="14px"
      py="8px"
      borderRadius="8px"
      _hover={{ bg: "whiteAlpha.200" }}
    >
      <Text fontSize="sm">Profile Settings</Text>
    </Flex>
  </MenuItem>

  {/* LOGOUT */}
  <MenuItem
    onClick={handleLogout}
    bg="transparent"
    _hover={{ bg: "transparent" }}
    _focus={{ bg: "transparent" }}
    px="0"
  >
    <Flex
      w="100%"
      px="14px"
      py="8px"
      borderRadius="8px"
      _hover={{ bg: "whiteAlpha.200" }}
    >
      <Text fontSize="sm">Logout</Text>
    </Flex>
  </MenuItem>

</Flex>
        </MenuList>
      </Portal>
    </Menu>
    </Flex >
  );
}
